var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.currentRow.id ? _vm.$t("编辑") : _vm.$t("新增"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("承保单位"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("name", $event);
      }
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "abbreviation",
      label: _vm.$t("单位简称"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("abbreviation", $event);
      }
    },
    model: {
      value: _vm.dataFrom.abbreviation,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "abbreviation", $$v);
      },
      expression: "dataFrom.abbreviation"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "logo",
      label: _vm.$t("单位logo"),
      hasFeedback: ""
    }
  }, [_c("a-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      headers: _vm.headers,
      data: {
        module: "logo"
      },
      "before-upload": _vm.beforeUpload
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.dataFrom.logo ? _c("img", {
    staticStyle: {
      width: "100px",
      height: "100px"
    },
    attrs: {
      src: _vm.dataFrom.logo,
      alt: "file"
    }
  }) : _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loading ? "loading" : "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("上传")) + " ")])], 1)]), _c("div", {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.$t("只能上传jpg/png格式文件，文件不能超过300kb，建议尺寸100*100")))])], 1), _c("div", {
    staticClass: "flexBox"
  }, [_c("a-form-model-item", {
    staticStyle: {
      flex: "1.8",
      "padding-left": "34px"
    },
    attrs: {
      prop: "disclosurePageName",
      label: _vm.$t("披露页名称"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入披露页名称"),
      maxLength: 40
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("disclosurePageName", $event);
      }
    },
    model: {
      value: _vm.dataFrom.disclosurePageName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "disclosurePageName", $$v);
      },
      expression: "dataFrom.disclosurePageName"
    }
  })], 1), _c("a-checkbox", {
    staticStyle: {
      flex: "0.5",
      "margin-bottom": "32px"
    },
    attrs: {
      checked: _vm.isDisclosureLink
    },
    on: {
      change: _vm.disclosureChange
    }
  }, [_vm._v(_vm._s(_vm.$t("设置跳转链接")))])], 1), _vm.isDisclosureLink ? _c("a-form-model-item", {
    attrs: {
      prop: "disclosurePageLink",
      label: _vm.$t("披露页链接"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入跳转链接")
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("disclosurePageLink", $event);
      }
    },
    model: {
      value: _vm.dataFrom.disclosurePageLink,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "disclosurePageLink", $$v);
      },
      expression: "dataFrom.disclosurePageLink"
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "flexBox"
  }, [_c("a-form-model-item", {
    staticStyle: {
      flex: "1.8",
      "padding-left": "34px"
    },
    attrs: {
      prop: "icpNo",
      label: _vm.$t("icp备案号"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入icp备案号"),
      maxLength: 40
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("icpNo", $event);
      }
    },
    model: {
      value: _vm.dataFrom.icpNo,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "icpNo", $$v);
      },
      expression: "dataFrom.icpNo"
    }
  })], 1), _c("a-checkbox", {
    staticStyle: {
      flex: "0.5",
      "margin-bottom": "32px"
    },
    attrs: {
      checked: _vm.isIcpLink
    },
    on: {
      change: _vm.icpChange
    }
  }, [_vm._v(_vm._s(_vm.$t("设置跳转链接")))])], 1), _vm.isIcpLink ? _c("a-form-model-item", {
    attrs: {
      prop: "icpLink",
      label: _vm.$t("icp备案号链接"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入跳转链接")
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("icpLink", $event);
      }
    },
    model: {
      value: _vm.dataFrom.icpLink,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "icpLink", $$v);
      },
      expression: "dataFrom.icpLink"
    }
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };